// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card.theme__modal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #f3f3f3;
  z-index: 200;
  text-align: center;
  box-shadow: 0 3rem 3rem rgba(0, 0, 0, 0.2);
  padding: 3rem;
  opacity: 0;
  animation: animateModal 500ms ease-in forwards;
}

@keyframes animateModal {
  to {
    opacity: 1;
  }
}

.card.theme__modal:hover {
  background: #f3f3f3;
}

.card.theme__modal small {
  display: block;
  margin-top: 0.6rem;
  width: 80%;
  margin-inline: auto;
}

.theme__primary-wrapper {
  margin: 3rem 0;
}

.theme__primary-colors {
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 1rem;
}

.theme__primary-colors button {
  width: 2rem;
  aspect-ratio: 1/1;
  border-radius: 50%;
  cursor: pointer;
}

.theme__primary-colors .color-1 {
  background: hsl(240, 100%, 20%);
}

.theme__primary-colors .color-2 {
  background: hsl(110, 70%, 46%);
}

.theme__primary-colors .color-3 {
  background: hsl(210, 70%, 46%);
}

.theme__primary-colors .color-4 {
  background: hsl(325, 70%, 46%);
}

.theme__primary-colors .color-5 {
  background: hsl(0, 70%, 46%);
}

.theme__primary-colors .color-6 {
  background: hsl(52, 70%, 46%);
}

.theme__background-colors {
  display: flex;
  gap: 2rem;
  justify-content: center;
  margin-top: 1rem;
}

.theme__background-colors button {
  width: 7rem;
  height: 2.5rem;
  background: white;
  border-radius: var(--border-radius-3);
  cursor: pointer;
}

.theme__background-colors .bg-2 {
  background: #111;
}

/* Media queries phones */
@media screen and (max-width: 600px) {
  .card.theme__modal {
    width: var(--container-width-md);
    padding: 3rem 1.5rem;
  }

  .theme__primary-colors {
    gap: 0.6rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/theme/theme.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;EACb,UAAU;EACV,8CAA8C;AAChD;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,qCAAqC;EACrC,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE;IACE,gCAAgC;IAChC,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".card.theme__modal {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background: #f3f3f3;\n  z-index: 200;\n  text-align: center;\n  box-shadow: 0 3rem 3rem rgba(0, 0, 0, 0.2);\n  padding: 3rem;\n  opacity: 0;\n  animation: animateModal 500ms ease-in forwards;\n}\n\n@keyframes animateModal {\n  to {\n    opacity: 1;\n  }\n}\n\n.card.theme__modal:hover {\n  background: #f3f3f3;\n}\n\n.card.theme__modal small {\n  display: block;\n  margin-top: 0.6rem;\n  width: 80%;\n  margin-inline: auto;\n}\n\n.theme__primary-wrapper {\n  margin: 3rem 0;\n}\n\n.theme__primary-colors {\n  display: flex;\n  gap: 1rem;\n  justify-content: center;\n  flex-wrap: wrap;\n  margin-top: 1rem;\n}\n\n.theme__primary-colors button {\n  width: 2rem;\n  aspect-ratio: 1/1;\n  border-radius: 50%;\n  cursor: pointer;\n}\n\n.theme__primary-colors .color-1 {\n  background: hsl(240, 100%, 20%);\n}\n\n.theme__primary-colors .color-2 {\n  background: hsl(110, 70%, 46%);\n}\n\n.theme__primary-colors .color-3 {\n  background: hsl(210, 70%, 46%);\n}\n\n.theme__primary-colors .color-4 {\n  background: hsl(325, 70%, 46%);\n}\n\n.theme__primary-colors .color-5 {\n  background: hsl(0, 70%, 46%);\n}\n\n.theme__primary-colors .color-6 {\n  background: hsl(52, 70%, 46%);\n}\n\n.theme__background-colors {\n  display: flex;\n  gap: 2rem;\n  justify-content: center;\n  margin-top: 1rem;\n}\n\n.theme__background-colors button {\n  width: 7rem;\n  height: 2.5rem;\n  background: white;\n  border-radius: var(--border-radius-3);\n  cursor: pointer;\n}\n\n.theme__background-colors .bg-2 {\n  background: #111;\n}\n\n/* Media queries phones */\n@media screen and (max-width: 600px) {\n  .card.theme__modal {\n    width: var(--container-width-md);\n    padding: 3rem 1.5rem;\n  }\n\n  .theme__primary-colors {\n    gap: 0.6rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
